import { render, staticRenderFns } from "./Owl.vue?vue&type=template&id=620f985a&"
import script from "./Owl.vue?vue&type=script&lang=js&"
export * from "./Owl.vue?vue&type=script&lang=js&"
import style0 from "./Owl.vue?vue&type=style&index=0&id=620f985a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports